var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"traceability"},[_c('PageTopNav',{attrs:{"tabsShow2":true,"tabList2":_vm.tabList2},on:{"changeTab2":_vm.changeTab2}}),_c('router-view'),_c('MyNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }